<template>
    <div class="create-bundle-confirm">
        <bundle-preview v-if="bundle" :bundle="bundle" />

        <div class="notice">
            <DsIcon name="alert-circle" class="alert" />
            <strong>{{ $t('campaignsPage.createBundle.notice') }}</strong>
        </div>
    </div>
</template>

<script>
import BundlePreview from './BundlePreview';

export default {
    components: {
        BundlePreview,
    },

    data() {
        return {
            bundle: {},
            nestedModal_title: this.$t('campaignsPage.createBundle.previewTitle'),
            nestedModal_actionText: this.$t('global.form.buttons.save'),
            nestedModal_actionMethod: 'save',
            nestedModal_actionClasses: 'small',
        };
    },

    methods: {
        nestedModal_open(bundle) {
            if (bundle) {
                this.bundle = bundle;
            }
        },

        save() {
            return this.$store.dispatch('automations/CREATE_BUNDLE', this.bundle)
                .then(() => {
                    this.$store.dispatch('automations/GET_BUNDLES');
                    this.$bus.$emit('POP_NESTED_MODAL', 2);
                })
                .catch(() => {
                    this.$error({
                        message: this.$t('notifications.error.bundlesPage.createBundle'),
                    });
                });
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .alert {
        --icon-color: #{$color-yellow};
        --icon-margin: 0 #{$spacing-100} 0 0;
    }

    .create-bundle-confirm {
        margin: -$spacing-300;

        .notice {
            border-bottom-right-radius: $border-radius;
            border-bottom-left-radius: $border-radius;
            background: $color-gray-10;
            border-top: 1px solid $color-gray-30;
            padding: $spacing-200;
            margin-top: auto;
            display: flex;
            align-items: center;
        }
    }

    [dir=rtl] .alert {
        --icon-margin: 0 0 0 #{$spacing-200};
    }
</style>
